// @flow

import _ from 'lodash';

import ApiObject from '../ApiObject';

import Menu from './Menu'

export default class CategoryItem extends ApiObject {

  /**
   *
   * @type {{CATEGORY: number, MENU: number, PRODUCT: number}}
   */
  static Type = {
    CATEGORY: 0,

    MENU: 1,

    PRODUCT: 2,
  };

  id: string;

  type: number;

  setTypeForObject(item) {
    this.type = item instanceof Menu ?
      CategoryItem.Type.MENU :
      CategoryItem.Type.PRODUCT;
  }

  isCategory(): boolean {
    return this.type === CategoryItem.Type.CATEGORY;
  }

  isMenu(): boolean {
    return this.type === CategoryItem.Type.MENU;
  }

  isProduct(): boolean {
    return this.type === CategoryItem.Type.PRODUCT;
  }

  fromCategory(category) {
    this.id = category.id;
    this.type = CategoryItem.Type.CATEGORY;
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/menu/CategoryItem.js